import axios from "axios";

const instance = axios.create({
  baseURL: "/api",
});

instance.interceptors.request.use((config) => {
  // eslint-disable-next-line no-param-reassign
  config.metadata = { startTime: new Date() };
  return config;
});

instance.interceptors.response.use(
  (response) => {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    response.config.metadata.endTime = new Date();
    response.duration =
      response.config.metadata.endTime - response.config.metadata.startTime;
    return response;
  },

  (error) => {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error

    // eslint-disable-next-line no-param-reassign
    error.config.metadata.endTime = new Date();
    // eslint-disable-next-line no-param-reassign
    error.duration =
      error.config.metadata.endTime - error.config.metadata.startTime;

    if (error.response.status === 401) {
      document.location.href = "/my-account/log-in";
      return null;
    }

    return Promise.reject(error);
  }
);

export default instance;
